import React from 'react';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Link } from '@/components/link/Link';
import { VariantComponentProps } from '../types';
import { Calculator } from 'lucide-react';

const AppointmentCTA: React.FC<VariantComponentProps<'appointment'>> = ({
  title,
  description,
  image,
  link,
}) => {
  return (
    <div className="mb-2 flex w-full flex-col-reverse items-center justify-between rounded-lg bg-neutral-0 px-2 py-6 md:flex-row md:px-10">
      <div className="flex w-full flex-col justify-center gap-5 md:w-2/3">
        {title && (
          <Headline
            variant="headingFour"
            title={title}
            className="!m-0 text-brand-700"
          />
        )}
        {description?.content && (
          <SerializeDescription
            description={description.content}
            className="text-sm text-neutral-700"
          />
        )}
        {link && (
          <Link {...link} className="mt-6 w-full !rounded-full md:w-max" />
        )}
      </div>

      {image?.image ? (
        <div className="relative my-4 flex h-56 w-full items-center justify-center md:my-0 md:w-52">
          <BaseImage
            {...image}
            className="h-full w-full"
            classNameImage="h-full w-full rounded-xl object-cover"
            sizes="(max-width: 768px) 100vw, 208px"
          />
        </div>
      ) : (
        <div
          style={{
            background:
              'linear-gradient(90deg, #AFD9F4 -15.71%, #E3F2FB 95.19%)',
          }}
          className="relative mb-4 flex items-center justify-center rounded-xl p-16 md:mb-0"
        >
          <Calculator className="h-24 w-24 text-brand-500" />
        </div>
      )}
    </div>
  );
};

export default AppointmentCTA;
